import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { PLinkModule } from '@panaya/ui/p-link';
import { PStaticProgressBarComponent } from './p-static-progress-bar.component';

@NgModule({
    declarations: [PStaticProgressBarComponent],
    imports: [CommonModule, MatProgressBarModule, PLinkModule],
    exports: [PStaticProgressBarComponent]
})
export class PStaticProgressBarModule {}
